import { Container } from './styles';

export interface CardProps {
  title: string;
  value: number;
  type: 'money' | 'quantity';
}

function CardResume({ title, value, type }: CardProps) {
  const newValue =
    type === 'money'
      ? new Intl.NumberFormat('pt-Br', {
          style: 'currency',
          currency: 'BRL',
        }).format(value)
      : value;

  return (
    <Container>
      <p>{title}</p>
      <h1>{newValue}</h1>
    </Container>
  );
}

export default CardResume;
